<script setup>
import { ref, computed } from 'vue'
import { useCatalogState } from '../composables/CatalogState.js'
import Drawer from '@/components/Drawer.vue'

const {
  isFilterVisible,
  selectedSortOption,
  isShowAllArticles,
  parameters
} = useCatalogState();

const sortOptions = ref([
  //{ id: "default", name: "Priporočeno" },
  { id: "alphanum-asc", name: "Po abecedi naraščajoče (A-Ž)" }, //Upošteva številke, npr. M3 je pred M12
  //{ id: "alpha-asc", name: "Po abecedi naraščajoče (A-Ž)" }, //Ne upošteva številk, npr. M12 je pred M3
  { id: "alphanum-desc", name: "Po abecedi padajoče (Ž-A)" },
  // { id: "alpha-desc", name: "Po abecedi padajoče (Ž-A)" },
  { id: "quantity-asc", name: "Po zalogi naraščajoče" },
  { id: "quantity-desc", name: "Po zalogi padajoče" },
  { id: "created-desc", name: "Nazadnje dodani artikli" },
]);

const emit = defineEmits([ "close", "parameterChanged" ]);

function close() {
  isFilterVisible.value = false;
  emit("close");
}

function onParameterChange(option, parameter) {
  emit("parameterChanged", value);
}
</script>


<template>
  <Drawer title="Filter prikaza" :visible="isFilterVisible" @close="close()">
    <div class="grid grid-cols-1 gap-4">

      <!-- Sort by -->
      <div>
        <Label>{{ $t('catalog.sort_by') }}</Label>
        <DropDown v-model="selectedSortOption" :options="sortOptions" :placeholder="$t('catalog.sort_by')" class="w-full"></DropDown>
      </div>

      <!-- Article options -->
      <div>
        <Label>Vsi artikli</Label>
        <div class="flex flex-row space-x-2">
          <CheckBox v-model="isShowAllArticles" label="Prikaži vse artikle (brez kategorij)" class="w-full"></CheckBox>
        </div>
      </div>

      <!-- Parameters -->
      <div class="grid grid-cols-1 gap-4">
        <template v-for="(parameter, pi) in parameters">
          <div v-if="parameter.options && parameter.options.length">
            <Label>{{ parameter.name }}</Label>
            <div class="relative grid sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-2 w-full text-center">
              <a href="#" v-for="(option, i) in parameter.options"
                @click.prevent="() => onParameterChange(option, parameter)"
                :class="{
                  'option-selected': !!option.selected,
                  'parameter-option-compact': !parameter.locked,
                  'parameter-option-compact-locked': parameter.locked
                }">
                {{ option.name || "--" }}
              </a>
            </div>
          </div>
        </template>
      </div>

    </div>
  </Drawer>
</template>